/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

export const cloneDtlSelector = (state) => state?.selectedCloneDtl;
const cloneDtlSlice = createSlice({
  name: 'selectedCloneDtl',
  initialState: {
    cloneDtl: null
  },
  reducers: {
    saveSelectedCloneDtl: (state, action) => {
      state.cloneDtl = action.payload;
    }
  }
});

// Export actions
export const { saveSelectedCloneDtl } = cloneDtlSlice.actions;

// Export reducer
export default cloneDtlSlice.reducer;
